import React from 'react';

import PropTypes, { Validator } from 'prop-types';

import { useDeprecate } from '@adsk/alloy-react-helpers';
import { StylableComponent } from '@adsk/alloy-react-theme';

import Avatar from './Avatar';

const Themes = {
  DARK: Avatar.COLORS.COLOR_7,
  LIGHT: Avatar.COLORS.COLOR_1,
} as const;

type AvatarAdapterThemes = typeof Themes;
type AvatarAdapterTheme = AvatarAdapterThemes[keyof AvatarAdapterThemes];

type AvatarAdapterUser = {
  name?: string;
  profileImg50?: string;
};

const AvatarAdapter = React.forwardRef<
  HTMLSpanElement,
  Omit<StylableComponent<HTMLSpanElement>, 'color'> & {
    user: AvatarAdapterUser;
    theme?: AvatarAdapterTheme;
  }
>(({ user, theme, ...props }, ref) => {
  useDeprecate(true, '@adsk/alloy-react-avatar', 'AvatarAdapter', 'Avatar');

  return (
    <Avatar
      ref={ref}
      name={user.name}
      image={user.profileImg50}
      color={theme}
      {...props}
    />
  );
});

AvatarAdapter.displayName = 'AvatarAdapter';

AvatarAdapter.defaultProps = {
  theme: Themes.LIGHT,
};

AvatarAdapter.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    profileImg50: PropTypes.string,
  }).isRequired as Validator<AvatarAdapterUser>,
  theme: PropTypes.oneOf(Object.values(Themes)),
};

export default Object.assign(AvatarAdapter, { Themes });
